<template>
  <div>
    <proposalHistory
      v-if="accessType !== 'NoAccess'"
      :access-type="accessType"
    />
    <h1 v-if="accessType == 'NoAccess'">No tienes acceso a esta seccion</h1>
  </div>
</template>

<script>
import proposalHistory from '@/views/provider/proposalHistory/ServiceProposalHistory';

export default {
  components: {
    proposalHistory,
  },
  computed: {
    accessType() {
      let accessType = 'NoAccess';

      if (this.userHasPermissions('proposal.administrator')) {
        accessType = 'Admin';
      } else if (this.userHasPermissions('proposal.evaluator')) {
        accessType = 'Evaluator';
      } else if (this.userHasPermissions('proposal.provider')) {
        accessType = 'Provider';
      }
      return accessType;
    },
  },
};
</script>
